import { render, staticRenderFns } from "./UserUploadSummary.vue?vue&type=template&id=63c95f5d&"
import script from "./UserUploadSummary.vue?vue&type=script&lang=js&"
export * from "./UserUploadSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports